import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getKnockoutBracketStyles = (theme: Theme) =>
  StyleSheet.create({
    root: {
      width: '100%',
    },
    treeContent: {
      paddingVertical: 28,
      paddingHorizontal: 8,
      alignItems: 'center',
    },
    row: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    emptyText: {
      paddingVertical: 48,
      paddingHorizontal: 24,
      textAlign: 'center',
      fontSize: 14,
      lineHeight: 20,
      color: theme.gray[500],
    },
  })
